// extracted by mini-css-extract-plugin
export default {"dateLabel":"dateLabel__PmRrp","formField":"formField__bUCKu","fieldValueTotal":"fieldValueTotal__eDqjK","chips":"chips___n2bB"};